import { cn } from "@/lib/utils";

type CloseIconProps = {
  onClick?: () => void;
  className?: string;
};

export default function CloseIcon({ className, onClick }: CloseIconProps) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      onClick={onClick}
    >
      <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" fill="#F3D5A9" />
      <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="#F3D5A9" />
      <line x1="22.9287" y1="22.6464" x2="37.778" y2="37.4957" stroke="black" />
      <line
        x1="22.2216"
        y1="37.6464"
        x2="37.0709"
        y2="22.7972"
        stroke="black"
      />
    </svg>
  );
}
